import React, { useMemo } from 'react'
import styled from 'styled-components'

import { CartFragment } from '../../../graphql/magento'
import { readCartDispensaryPromoCodes } from '../../../lib/cart/dispensary-promo'
import { totalQuantityExcludingDependents } from '../../../lib/cart/item'
import { useDispensaryCartStatus } from '../../../lib/dispensaries/events/cart'
import AddPromoCode from './AddPromoCode'
import AppliedPromoCode from './AppliedPromoCode'

export interface PromoCodeContainerProps {
  cart: CartFragment
  className?: string
}

const PromoCodeContainer: React.FC<PromoCodeContainerProps> = ({ cart, className }) => {
  const { loading } = useDispensaryCartStatus()
  const {
    applied_coupons: appliedCoupons,
    dispensary_promo_code: dispensaryPromoCode,
    id,
    items,
    total_quantity: totalQuantity,
  } = cart

  const cartDispensaryPromoCodes = useMemo(
    () => (dispensaryPromoCode ? readCartDispensaryPromoCodes(dispensaryPromoCode) : undefined),
    [dispensaryPromoCode],
  )
  const cartTotalQuantity = totalQuantityExcludingDependents(items, totalQuantity)

  if (loading) {
    return null
  }

  return (
    <div className={className} data-cy="promocode-container">
      {!!appliedCoupons?.length && (
        <AppliedPromoCode
          appliedCoupons={appliedCoupons}
          cartDispensaryPromoCodes={cartDispensaryPromoCodes}
          cartId={id}
        />
      )}
      <AddPromoCode
        cartDispensaryPromoCodes={cartDispensaryPromoCodes}
        cartId={id}
        isEmptyCart={cartTotalQuantity === 0}
      />
    </div>
  )
}

const StyledPromoCodeContainer = styled(PromoCodeContainer)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
  padding-bottom: 10px;
  margin-bottom: 20px;
  max-width: 420px;
  width: 100%;
`

export default StyledPromoCodeContainer
